import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";

var submitHomework = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var homeworkId, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            homeworkId = _ref.homeworkId;
            _context.next = 3;
            return http.post("".concat(constants.API_URL, "/homeworks/").concat(homeworkId, "/submit"));

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function submitHomework(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var unSubmitHomework = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var homeworkId, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            homeworkId = _ref3.homeworkId;
            _context2.next = 3;
            return http.post("".concat(constants.API_URL, "/homeworks/").concat(homeworkId, "/unsubmit"));

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function unSubmitHomework(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var restoreHomework = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var homeworkId, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            homeworkId = _ref5.homeworkId;
            _context3.next = 3;
            return http.post("".concat(constants.API_URL, "/homeworks/").concat(homeworkId, "/restore"));

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function restoreHomework(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

var cancelHomework = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var homeworkId, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            homeworkId = _ref7.homeworkId;
            _context4.next = 3;
            return http.post("".concat(constants.API_URL, "/homeworks/").concat(homeworkId, "/cancel"));

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function cancelHomework(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

var deleteHomework = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var homeworkId, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            homeworkId = _ref9.homeworkId;
            _context5.next = 3;
            return http["delete"]("".concat(constants.API_URL, "/homeworks/").concat(homeworkId));

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function deleteHomework(_x5) {
    return _ref10.apply(this, arguments);
  };
}();

var updateHomeworkStudentGrades = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11) {
    var homeworkId, data, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            homeworkId = _ref11.homeworkId, data = _ref11.data;
            _context6.next = 3;
            return http.patch("".concat(constants.API_URL, "/homeworks/").concat(homeworkId, "/student-grades"), data);

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function updateHomeworkStudentGrades(_x6) {
    return _ref12.apply(this, arguments);
  };
}();

var addHomeworkAttachments = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13) {
    var homeworkId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            homeworkId = _ref13.homeworkId, data = _ref13.data, onUploadProgress = _ref13.onUploadProgress;
            _context7.next = 3;
            return http.post("".concat(constants.API_URL, "/homeworks/").concat(homeworkId, "/attachments"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function addHomeworkAttachments(_x7) {
    return _ref14.apply(this, arguments);
  };
}();

var deleteHomeworkAttachments = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref15) {
    var homeworkId, data, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            homeworkId = _ref15.homeworkId, data = _ref15.data;
            _context8.next = 3;
            return http.post("".concat(constants.API_URL, "/homeworks/").concat(homeworkId, "/delete-attachments"), data);

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function deleteHomeworkAttachments(_x8) {
    return _ref16.apply(this, arguments);
  };
}();

var getHomework = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref17) {
    var homeworkId, response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            homeworkId = _ref17.homeworkId;
            _context9.next = 3;
            return http.get("".concat(constants.API_URL, "/homeworks/").concat(homeworkId));

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getHomework(_x9) {
    return _ref18.apply(this, arguments);
  };
}();

var updateHomework = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref19) {
    var homeworkId, data, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            homeworkId = _ref19.homeworkId, data = _ref19.data;
            _context10.next = 3;
            return http.patch("".concat(constants.API_URL, "/homeworks/").concat(homeworkId), data);

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function updateHomework(_x10) {
    return _ref20.apply(this, arguments);
  };
}();

var copyHomework = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref21) {
    var homeworkId, data, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            homeworkId = _ref21.homeworkId, data = _ref21.data;
            _context11.next = 3;
            return http.post("".concat(constants.API_URL, "/homeworks/").concat(homeworkId, "/copy"), data);

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function copyHomework(_x11) {
    return _ref22.apply(this, arguments);
  };
}();

export default {
  submitHomework: submitHomework,
  unSubmitHomework: unSubmitHomework,
  restoreHomework: restoreHomework,
  cancelHomework: cancelHomework,
  deleteHomework: deleteHomework,
  updateHomeworkStudentGrades: updateHomeworkStudentGrades,
  addHomeworkAttachments: addHomeworkAttachments,
  deleteHomeworkAttachments: deleteHomeworkAttachments,
  getHomework: getHomework,
  updateHomework: updateHomework,
  copyHomework: copyHomework
};